import type { Video } from 'pkg/api/models/video';

export function isNew(video: Video): boolean {
	return video.createdAt + 3600 * 24 > Math.floor(Date.now() / 1000);
}
